export const LOAD_GERENTES = 'LOAD_GERENTES';
export const GERENTES_DATA = 'GERENTES_DATA';
export const SHOW_GERENTE = 'SHOW_GERENTE';
export const GET_GERENTE = 'GET_GERENTE';
export const STORE_GERENTE = 'STORE_GERENTE';
export const UPDATE_GERENTE = 'UPDATE_GERENTE';
export const CHANGE_STATUS_CODE = 'CHANGE_STATUS_CODE';
export const GERENTE_ERROR = 'GERENTE_ERROR';
